import { render, staticRenderFns } from "./LocusZoomIntervalsPanel.vue?vue&type=template&id=5eeef908&"
import script from "./LocusZoomIntervalsPanel.vue?vue&type=script&lang=js&"
export * from "./LocusZoomIntervalsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eeef908')) {
      api.createRecord('5eeef908', component.options)
    } else {
      api.reload('5eeef908', component.options)
    }
    module.hot.accept("./LocusZoomIntervalsPanel.vue?vue&type=template&id=5eeef908&", function () {
      api.rerender('5eeef908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/panels/LocusZoomIntervalsPanel.vue"
export default component.exports